var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Sidesheet",
    {
      attrs: { active: _vm.active, "hide-footer": true },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(" ТМЦ "),
              _vm.hasItem
                ? _c("span", { staticClass: "guid" }, [
                    _vm._v(" №" + _vm._s(_vm.item.guid) + " "),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.busy
            ? _c("Loader", {
                attrs: {
                  label: "Данные загружаются",
                  height: "300",
                  active: _vm.busy,
                },
              })
            : _c(
                "div",
                { staticClass: "content" },
                [
                  _vm.hasItem
                    ? _c("div", { staticClass: "name" }, [
                        _vm._v(" " + _vm._s(_vm.item.name) + " "),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "path" }, [
                    _vm._v(" " + _vm._s(_vm.path) + " "),
                  ]),
                  _vm.hasItem
                    ? _c("div", { staticClass: "parameters" }, [
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Срок годности: "),
                          _c("b", [_vm._v(_vm._s(_vm.item.exp_date || "—"))]),
                        ]),
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Примерная стоимость: "),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.formatAsCurrency(_vm.item.cost) || "—")
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Дата производства: "),
                          _c("b", [_vm._v(_vm._s(_vm.item.manuf_date || "—"))]),
                        ]),
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Дата покупки: "),
                          _c("b", [_vm._v(_vm._s(_vm.item.purch_date || "—"))]),
                        ]),
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Модель: "),
                          _c("b", [_vm._v(_vm._s(_vm.item.model || "—"))]),
                        ]),
                        _c("div", { staticClass: "parameters__item" }, [
                          _vm._v(" Где приобретено: "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.item.purch_place || "—")),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.sections.length > 0
                    ? _c("Switcher", {
                        staticClass: "h-switcher",
                        attrs: { type: "group", items: _vm.tabs },
                        model: {
                          value: _vm.currentSection,
                          callback: function ($$v) {
                            _vm.currentSection = $$v
                          },
                          expression: "currentSection",
                        },
                      })
                    : _vm._e(),
                  !!_vm.currentSectionData
                    ? [
                        _vm.currentSectionDocuments.length > 0
                          ? _c(
                              "div",
                              [
                                _c("files", {
                                  attrs: {
                                    files: _vm.currentSectionDocuments,
                                    actions: "loadFiles,preview",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.currentSectionData.description
                          ? _c("div", { staticClass: "description" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currentSectionData.description) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm.currentSectionData.link
                          ? _c("div", { staticClass: "link" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.currentSectionData.link,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.currentSectionData.link) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "link__copy",
                                  on: { click: _vm.copyLinkToClipboard },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: { name: "copy", size: 16 },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm.currentSectionImages.length > 0
                          ? _c(
                              "div",
                              { staticClass: "images" },
                              [
                                _c("files", {
                                  attrs: {
                                    files: _vm.currentSectionImages,
                                    actions: "loadFiles,preview",
                                    "show-video": true,
                                    "full-width": true,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }